import React from "react"

type Props = {
    children: React.ReactNode
}

export const StaticFooter = (props: Props) => {
    return <div className="row m-0 py-1 fixed-bottom pr-0 pr-md-5 pr-xl-0">
        <div className={"col-lg-12 mx-auto col-xl-11 pt-3 pl-4 pr-4 pr-md-5 pr-xl-4"}>
            <div className="col-12 ui-module sticky-bottom-module">
                {props.children}
            </div>
        </div>
    </div>
}




// WEBPACK FOOTER //
// ./src/common/footer/StaticFooter.tsx